import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1AAF5D",
      fillRule: "evenodd",
      d: "M12.411 21.356c-.434-.29-1.185-.973-1.185-.973l-.375-.964s.306-.084.375-.318c.07-.234-.02-.524-.05-.552-.029-.028-.335.047-.424.168s-.227.59-.434.43.03-.336.03-.336.207-.244.197-.375c-.01-.13-.276-.523-.306-.533s-.089.515-.168.57c-.079.057-.187.291-.345.16s.078-.328.078-.328.445-.224.01-.963c-.128.318-.375.524-.375.524s-.118.196-.227.028c-.109-.169.128-.328.128-.328s.386-.215.395-.533-.464-.683-.464-.683-.03.59-.177.664c-.148.075-.208.197-.376.066-.167-.131.129-.421.129-.421s.513-.487.484-.768c-.03-.28-.06-.327-.06-.327s-.385.225-.434.337c-.05.112-.207.514-.405.393-.138-.15.119-.44.119-.44s.187-.196.177-.28-.158-.338-.444-.58c-.04-.076-.06-.375-.06-.375s-.216.243-.206.374-.02.393.01.683-.238-.093-.238-.093l.05-.936s-.375-.43-.83-.59c.168.234.158.459.158.459s-.187.384-.187.486c0 .103.286.411.543.852-.385-.4-1.293-.421-1.52-.543.108.122.434.58.394.702s.583.374.583.374l.661.01s.326.215.356.355-.474-.262-.672-.252c-.197.009-.72-.066-.72-.066s.316.28.325.402.149.403.336.478.691.103.691.103.217-.122.257.009c.04.13-.286.234-.286.234s-.336 0-.445-.084c-.108-.085-.128-.225-.612-.281-.05.383.267.776.267.776s1.333-.102 1.323.169-1.106.028-1.145-.056c-.04-.084.049.533.306.664.256.131.829.066.898.038s.326-.057.326.084c0 .14-1.303.252-1.323.215s.197.477.72.45c.524-.029.751-.179.751-.179s.316-.056.346.066-.316.178-.316.178-.83.018-.86-.02c-.029-.037.188.497.77.487.435-.037.465-.215.554-.243.128-.028.404-.028.444-.019s.73.468.73.468l1.758 1.685.582-.459s-.128-.253-.592-.243",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#2C97DE",
      fillRule: "evenodd",
      d: "M23.172 17.686c-.007-.006-.32-.47-.32-.47l-.967 3.713.226.81L21.548 24l-.464-.721-.75.369.602-2.381.556-.49 1.001-3.658-.556.085L23.333 15s-.153 2.692-.16 2.686",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#2C97DE",
      fillRule: "evenodd",
      d: "M24.955 18.174c-.005-.01-.12-.573-.12-.573l-2.259 2.084L20.166 22l-.008-.477-.825-.101 1.092-.83.558-.092 3.523-3.177-.615-.234L26.334 16s-1.375 2.183-1.38 2.174",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#2C97DE",
      fillRule: "evenodd",
      d: "M24.642 16.422c-.008-.007-.29-.5-.29-.5l-2.775 4.547.114.79L20.695 23l-.411-.762-.95.175 1.064-1.843.745-.326 2.806-4.489-.669-.044L25.333 14s-.684 2.43-.691 2.422",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M18.154 18.174s.795 1.736 1.814 1.555c.653.226.757.737.757.737s.732-.1 1.011.511c.206.128.594-.3.594-.3s.03-.414-.088-.7c-.117-.285-.506-.302-.902-.248-.415-1.14-.992-1.97-2.043-2.78 4.721-1.123 9.778-7.858 8.655-7.946l-5.909 1.738s-.75 0-1.006.069c-.256.07-1.166.606-1.13 1.43.035.824.432.963.44.973.01.01.707.159.416.685-.292.526-.874-.179-.874-.179s-.917.28-2 .667c.526-1.688-.004-3.295-.478-3.91.163-1.202-.92-1.48-1.167-1.473-.205-.03-.735.168-.82.432-.269.095-.283.337-.283.337s-.551.103-.622.6c.325-.277.537.03.537.03s.283.205.432.213c-.263 1.47-.84 2.307-.976 2.385.188.72.45.72.713 1.42-1.288-.402-2.447-.7-2.447-.7s-.582.704-.874.178c-.291-.526.406-.675.415-.685s.406-.15.442-.973c.035-.824-.875-1.36-1.13-1.43-.257-.07-1.008-.07-1.008-.07L4.716 9.004s-.415-.06-.38.357c.026.305 2.571 5.06 9.027 7.59-1.458 1.076-2.084 2.497-2.144 2.75-.25.021-.73.073-.847.367-.171.492.499.94.565.863.111.035.047.136.252.004-.155-.211-.139-.415.017-.469.156-.056.41.195.41.195s.092-.456.743-.689c1.017.186 2.342-1.797 2.342-1.797s-.145 1.211.042 1.5c-1.177.22-1.38 1.255-1.38 1.255s1.4 3.045 2.964 3.025c1.563-.02 3.043-2.735 3.035-2.972s-.495-1.228-1.396-1.29c.203-.22.189-1.518.189-1.518",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M14.408 14.08c.767-.029 1.916-.49 1.916-.49s1.021.535 1.851.461 1.98-.49 1.98-.49c.686 3.187-.879 6.047-3.831 7.334-3.134-1.332-4.656-4.533-3.751-7.334 0 0 1.07.55 1.835.52",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M14 19.295a6.4 6.4 0 0 1-.666-.832v-3.13H14zm1.334 1.086a7 7 0 0 1-.667-.473v-4.575h.667zm1.333.354a8 8 0 0 1-.343.16 7 7 0 0 1-.324-.147v-5.415h.667zM18 19.88q-.315.255-.666.48v-5.028H18zm1.334-1.48a6 6 0 0 1-.667.856v-3.924h.666z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#2C97DE",
      fillRule: "evenodd",
      d: "M14.413 13.782c.763-.026 1.907-.423 1.907-.423s1.017.461 1.844.397 1.971-.423 1.971-.423c.167.8.206 1.26.176 2h-7.988c-.048-.804-.045-1.15.262-2 0 0 .266.119.628.234.361.116.818.228 1.2.215M2.334 14l1.471.008-.147.397.642 2.848.776-2.84L4.802 14h1.532l-.328.397-1.264 4.07.327.533H3.598l.327-.532-1.237-4.056zm25 0h1.89l-.307.36-.009 4.241.425.399h-2l.399-.43-.01-4.202z",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagVir = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagVir_default = SvgFlagVir;

export { FlagVir_default as default };
